import ThemeApi from '@/api/Theme'

export class ThemeModel {
  constructor(item) {
    const { id, name, color, preview } = item
    this.id = Number(id) || undefined
    this.name = name || undefined
    this.color = color || undefined
    this.preview = preview || undefined
  }
  static async save(obj, systemOwnerId) {
    const ret = await ThemeApi.saveTheme(obj, systemOwnerId)
    return ret
  }
}
